import { render, staticRenderFns } from "./GeneralErrorIcon.vue?vue&type=template&id=01dc571e"
import script from "./GeneralErrorIcon.vue?vue&type=script&lang=js"
export * from "./GeneralErrorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports